import React, { Component } from 'react';
import { SnackBarHelper } from '@lyearn-team/frontend-components';
import { BadgeView } from '../../learner/components/ViewBadge/components/DarkBadgePopup';
import windowResize from '../../helper/WindowResize';

class BadgePreview extends Component {
  render() {
    const { issueId, windowWidth } = this.props;
    if (!issueId) {
      return SnackBarHelper.showSnackbar({
        label: 'Badge issueId is missing, please enter correct URL.',
        status: 'error'
      });
    }
    return (
      <BadgeView
        badge={{ issueId }}
        renderActions={false}
        onClose={() => window.history.back()}
        show={true}
        isMobile={windowWidth < 767}
      />
    );
  }
}

export default windowResize(BadgePreview);
